var slickIndex = [];
var $currentVariantInput = $('#current-variant');
var timer;
window.SwymCallbacks = window.SwymCallbacks || [];

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];
  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');

    var tables = [...document.querySelectorAll('.rte__table-wrapper')];
    tables.forEach(function(element) {
      var scrollMore = document.querySelector('span');
      scrollMore.classList.add('rte__table-scroll');
      scrollMore.innerHTML = theme.strings.tableScrollMore + " →";
      element.append(scrollMore);
    });
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size == null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  return {}
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
    * @param {object} options - Settings from `product.json from shopify`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.letterField = options.letterField;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    $(this.letterField, this.$container).on('keyup input change', this._onLetterChange.bind(this));


    $currentVariantInput.val(this.currentVariant.id);
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');
          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find options based on the message input
     */
    _getLetterOptions: function() {
      var currentOptions = {};

      var letterCounter = _.chain($(this.letterField, this.$container))
        .map(function(element) {
          // Subtract the number of spaces from the total amount characters in the input field
          var $message = $(element).val();
          return $message.length - ($message.split(' ').length - 1)
        })
        .reduce(function(a, b) {
          // Sum the total amount of characters of each available input field
          return a + b
        })
        .value()

      currentOptions.value = letterCounter == 0 ? '0' : letterCounter;
      currentOptions.index = 0;

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    _getVariantFromLetter: function() {
      var selectedValues = this._getLetterOptions();
      var variants = this.product.variants;


      var found = _.find(variants, function(variant) {
        return variant.title == selectedValues;
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onLetterChange: function() {
      var variant = this._getVariantFromLetter();

      this.$container.trigger({
        type: 'letterChange',
        variant: variant
      });

      if (!variant) {
        $currentVariantInput.val('');
        return;
      }

      this._updateMasterSelect(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      $currentVariantInput.val(this.currentVariant.id);
    },

    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        $currentVariantInput.val('');
        return;
      }

      this._updateMasterSelect(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      $currentVariantInput.val(this.currentVariant.id);

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */

    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();

/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }


    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on('keyup.drawer', $.proxy(function(evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        this.close();
        return false;
      } else {
        return true;
      }
    }, this));

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on('click.drawer', $.proxy(function() {
      this.close();
      return false;
    }, this));
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();


/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header--wrapper',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input-mobile',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    countrySwitch: '[js-switchTrigger]'
  };

  var classes = {
    focus: 'search--focus',
    mobileNavIsOpen: 'js-menu--is-open'
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    initDrawer();
    searchSubmit();
    toggleSwitch();

    $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on('focus blur', function() {
      $(selectors.searchHeader).toggleClass(classes.focus);
    });
  }

  function initDrawer() {
    // Add required classes to HTML
    $('#PageContainer').addClass('drawer-page-content');
    $('.js-drawer-open-top').attr('aria-controls', 'SearchDrawer').attr('aria-expanded', 'false');
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchSubmit() {
    $(selectors.searchSubmit).on('click', function(evt) {
      var $el = $(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        searchFocus($input);
      }
    });
  }

  function toggleSwitch() {
    $(selectors.countrySwitch).on('click', function(evt) {
      evt.preventDefault();
      $('[js-switchContainer]').fadeToggle();
    });
  }

  return {
    init: init
  };
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });

})();

window.theme = theme || {};

theme.customerTemplates = (function() {

  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/*================ SECTIONS ================*/
window.theme = window.theme || {};

window.theme = window.theme || {};

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : '';

  function Map(container) {
    this.$container = $(container);

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key)
            .then(function() {
              apiStatus = 'loaded';
              initAllMaps();
            });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({address: address}, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(function(results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            disableDefaultUI: true
          };

          var map = this.map = new google.maps.Map($map[0], mapOptions);
          var center = this.center = map.getCenter();

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });

          google.maps.event.addDomListener(window, 'resize', $.debounce(250, function() {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
          }));
        }.bind(this))
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          $map
            .parent()
            .addClass('page-width map-section--load-error')
            .html('<div class="errors text-center">' + errorMessage + '</div>');
        });
    },

    onUnload: function() {
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  $('.map-section').addClass('map-section--load-error');
  $('.map-section__container').remove();
  $('.map-section__link').remove();
  $('.map-section__overlay').after('<div class="errors text-center">' + theme.strings.authError + '</div>');
}

/**
 * Featured products
 */
theme.FeaturedProducts = (function() {
  function FeaturedProducts(container) {
    this.container = container;
    this.prodContainerSelector = '[js-products="container"]';
    this.collections = container.querySelectorAll('[js-collection]');
    this.activeCollection = container.querySelector('[js-collection="active"]');
    this.activeCollectionHandle = this.activeCollection.dataset.collectionHandle;

    // Add event listeners to all the collection elements
    Array.from(this.collections).forEach(this.bindEventListeners.bind(this));

    // Call this once initally (may want to use liquid instead)
    // Delayed to solve interference with instagram feed
    setTimeout(function() {
      this.request();
    }.bind(this), 2000);
  }

  /**
   * Bind event listeners to each collection
   * @param {Node} item - Collection link.
   */
  FeaturedProducts.prototype.bindEventListeners = function(item) {
    item.addEventListener('click', this.setActive.bind(this));
  }

  /**
   * Bind event listeners to each collection
   * @param {Object} evt - Click event.
   */
  FeaturedProducts.prototype.setActive = function(evt) {
    // Clear all active state
    Array.from(this.collections).forEach(function(item) {
      item.setAttribute('js-collection', '');
    });

    // Add active to the element clicked
    evt.target.setAttribute('js-collection', 'active');
    this.activeCollection = evt.target;

    this.activeCollectionHandle = evt.target.dataset.collectionHandle;

    this.request();
  }

  /**
   * GraphQL request
   */
  FeaturedProducts.prototype.request = function() {
    // GraphQL query to get product data based off collection handle
    var query = '{ ' +
      'collectionByHandle(handle: "' + this.activeCollectionHandle + '") { ' +
       'products(first: 4) { ' +
          'edges { ' +
            'node { ' +
              'id ' +
              'title ' +
              'onlineStoreUrl ' +
              'variants(first: 1) { ' +
                'edges { ' +
                  'node { ' +
                    'id ' +
                    'title ' +
                    'image { ' +
                      'src ' +
                    '} ' +
                    'price ' +
                  '} ' +
                '} ' +
              '} ' +
            '} ' +
          '} ' +
        '} ' +
      '} ' +
    '}';

    // Request
    $.ajax({
      type: 'POST',
      beforeSend: function(request) {
        // Storefront access token request header
        request.setRequestHeader(
          'X-Shopify-Storefront-Access-Token',
          theme.strings.storefrontAccessToken
        );
        request.setRequestHeader('Accept', 'application/json');
      },
      url: theme.strings.graphqlEndpoint,
      contentType: 'application/json',
      data: JSON.stringify({ query: query}),
      success: this.handler.bind(this),
      error: function(error) {
        console.error(error)
      }
    });
  }

  /**
   * Request handler
   * @param {Object} res - Response from request.
   */
  FeaturedProducts.prototype.handler = function(res) {
    // Get products from request response
    var products = res.data.collectionByHandle.products.edges;
    var productsContainer = this.container.querySelector(this.prodContainerSelector);

    // Unslick carsousel if previously initiated
    if (productsContainer.classList.contains('slick-initialized')) {
      $(this.prodContainerSelector).slick('unslick');
    }

    // Empty container
    while (productsContainer.firstChild) {
      productsContainer.removeChild(productsContainer.firstChild);
    }

    // Render each product
    products.forEach(this.render.bind(this));

    // Add link to collection
    this.container.querySelector(this.prodContainerSelector)
      .insertAdjacentHTML('beforeend', '<div ' +
        'class="grid__item featured-products__cta"' +
      '>' +
        '<a ' +
          'class="btn btn--primary"' +
          'href="/collections/'+ this.activeCollectionHandle + '"' +
        '>' +
          'Shop all' +
          theme.strings.iconArrowBtn +
        '</a>' +
      '</div>');

    // Init wishlist buttons
    window.SwymCallbacks.push(
      this.initWishlist.bind(this)
    );

    // Refresh reviews
    api.refreshWidgets();
  }

  /**
   * Render each product
   * @param {Object} data - Product data.
   */
  FeaturedProducts.prototype.render = function(data) {
    var product = data.node;
    var firstVariant = product.variants.edges[0].node;
    var productId = this.decode(product.id);
    var variantId = this.decode(firstVariant.id);

    // Template used to render each product
    var template = '<div class="grid__item one-half large-up--one-quarter">' +
      '<div class="grid-view-item"> ' +
        '<a href="' + product.onlineStoreUrl + '" class="grid-view-item__link">' +
          '<img ' +
            'class="grid-view-item__image lazyload" ' +
            'src="' + firstVariant.image.src + '"' +
          '>' +
          '<div class="grid-view-item__title">' +
            product.title +
          '</div>' +
          '<div class="grid-view-item__meta">' +
            '<div class="grid-view-item__prices">' +
              '<span class="product-price__price">' +
                firstVariant.price +
              '</span>' +
            '</div>' +
          '</div>' +
        '</a>' +
        '<div class="grid-view-item--btn_wrapper">' +
          '<button ' +
            'class="btn btn--secondary btn--wishlist product_' + productId + '"' +
            'data-swaction="addToWishlist" ' +
            'data-product-id="' + productId + '"' +
            'data-variant-id="' + variantId + '"' +
          '>' +
            theme.strings.iconWishlist +
          '</button>' +
          '<div class="grid-view-item--btn_container">' +
            '<a class="btn btn--small">' +
              'Personalise' + theme.strings.iconArrowBtn
            '</a>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';

    this.container.querySelector(this.prodContainerSelector)
      .insertAdjacentHTML('beforeend', template);
  }

  /**
   * Init wishlist buttons
   */
  FeaturedProducts.prototype.initWishlist = function() {
    window._swat.initializeActionButtons(
      this.prodContainerSelector,
      '.btn--wishlist'
    );
  }

  /**
   * Decode a string
   * @param {String} item - String to decode.
   */
  FeaturedProducts.prototype.decode = function(item) {
    var itemDecode = window.atob(item);
    var itemN = itemDecode.lastIndexOf('/');
    var item = itemDecode.substring(itemN + 1);

    return item;
  }

  return FeaturedProducts;
})();

/**
 * Embeded vimeo video
 */
theme.PersonalisationPage = (function() {
  function PersonalisationPage(container) {
    this.container = container;
    this.videoContainers = container.querySelectorAll('[js-video="container"]');

    this.init();

    document.addEventListener('mouseup', this.closeVideos.bind(this));

    ['load', 'resize', 'scroll'].forEach(function(event) {
      document.addEventListener(event,
        $.debounce(250, this.videoAutoplayHandler.bind(this))
      );
    }.bind(this));
  }

  PersonalisationPage.prototype.init = function() {
    Array.from(this.videoContainers).forEach(function(item) {
      var button = item.querySelector('[js-button]');

      button.addEventListener('click', this.openVideo.bind(item));
    }.bind(this));
  }

  /**
   * Open video
   */
  PersonalisationPage.prototype.openVideo = function() {
    var video = this.querySelector('[js-video]');

    this.setAttribute('js-state', 'show');

    video.play();
  }

  /**
   * Close video
   * @param {Object} evt - Mouse up event.
   */
  PersonalisationPage.prototype.closeVideos = function(evt) {
    Array.from(this.videoContainers).forEach(function(item) {
      var video = item.querySelector('[js-video]')

      if (item.contains(evt.target)) {
        return;
      }

      item.setAttribute('js-state', 'hide');

      video.pause();
    });
  }

  /**
   * Apply visibility tracking function to all video elements
   */
  PersonalisationPage.prototype.videoAutoplayHandler = function() {
    Array.from(this.videoContainers).forEach(this.visibilityChange.bind(this));
  }

  /**
   * Autoplays video if it is in view
   * @param {Node} element - Video wrapper element.
   */
  PersonalisationPage.prototype.visibilityChange = function(element) {
    var elementOldState;
    var elementState = this.elementInView(element);
    var videoState = element.getAttribute('js-state');

    if (elementState && (videoState != 'show')) {
      this.openVideo.bind(element)();
    }

    if (elementOldState != elementState) {
      elementOldState = elementState;
    }
  }

  /**
   * Returns boolean based on if video is in full view or not
   * @param {Node} element - Video wrapper element.
   * @return {Boolean}
   */
  PersonalisationPage.prototype.elementInView = function(element) {
    var rect = element.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  return PersonalisationPage;
})();

$(document).ready(function() {
  var sections = new theme.Sections();

  sections.register('product', theme.Product);
  sections.register('product-template', theme.Product);
  sections.register('map', theme.Maps);
  sections.register('featured-products', theme.FeaturedProducts);
  sections.register('personalisation-page', theme.PersonalisationPage);
});

theme.init = function() {
  theme.customerTemplates.init();

  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

};

$(theme.init);


/* ================ CUSTOM ================ */

// Account and Help pages mobile select

function goToNewPage() {
  var url = document.getElementById('list').value;
  if(url != 'none') {
    window.location = url;
  }
}

$(document).ready(function() {
  var webPage = window.location.href;
  var nextPage = webPage.replace('https://emmabridgewater.myshopify.com','');
  var currentPage = nextPage.replace('https://www.emmabridgewater.co.uk','');

  $('.account-menu__select option').each(function( index ) {
    var optionValue = $(this).val();

    if (optionValue == currentPage) {
      $(this).attr('selected','true');
    }
  });
});

// Footer Accordion

// Read More link collection descriptions

$(document).ready(function() {

  var collection_hero_desc = $('.collection-hero__description')
  var words = collection_hero_desc.text().split(' ');

  if (words.length < collection_hero_desc.attr("data-max-characters")) {
    $('.readMore').hide();
  };

  $(document).on("click", ".collection-hero__description .readMore", function(){
    $('.collection-hero__description.small').hide();
    $('.collection-hero__description.large').show();

    $('.collection-image').toggleClass('hide');
    $('.collection-desc').toggleClass('medium-up--one-whole').removeClass('medium-up--one-half');
    $('.collection-hero__description').addClass('desc--small-width');
  });

  $(document).on("click", ".collection-hero__description .readLess", function(){
    $('.collection-hero__description.small').show();
    $('.collection-hero__description.large').hide();

    $('.collection-image').toggleClass('hide');
    $('.collection-desc').toggleClass('medium-up--one-whole').addClass('medium-up--one-half');
    $('.collection-hero__description').removeClass('desc--small-width');
  });
});

// Collection header image resize
$(window).on('load resize', function(){
  var containerCollectionHeight = $('.collection-desc').height();
  $('.collection-hero__image').css('height', containerCollectionHeight);

  var containerBlogHeight = $('.collection-desc').height();
  $('.blog-hero__image').css('height', containerBlogHeight);
});